import { Box, Button, IconButton, Typography } from '@mui/material';

import { useLocale } from 'hooks/useLocale';
import { useModalControl } from 'hooks/useModalControl';

import LanguagePickerDialog from 'components/@common/LanguagePickerDialog';
import Icon from 'components/@icons/Icon';

const LanguagePickerButton = () => {
  const { locale } = useLocale();
  const { open, onClose, onOpen } = useModalControl();

  return (
    <>
      <IconButton key={locale} component={Button} onClick={onOpen} size="small">
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Icon name="Globe" />

          <Typography
            variant="small"
            sx={{
              fontWeight: 'bold',
              letterSpacing: 'normal',
              textTransform: 'uppercase',
              mt: '2px',
            }}
          >
            {locale}
          </Typography>
        </Box>
      </IconButton>
      <LanguagePickerDialog open={open} onClose={onClose} />
    </>
  );
};

export default LanguagePickerButton;
